var exports = {
  "uW": "xf61da738--c8e632--section",
  "R_": "xf61da738--c8e632--heading",
  "kO": "xf61da738--c8e632--heading-title",
  "BJ": "xf61da738--c8e632--heading-muted",
  "Bm": "xf61da738--c8e632--offers-list",
};

module.exports = exports;
